import {connect} from 'react-redux'
import styles from './ActionBar.css'
import {DropdownButton, MenuItem} from 'react-bootstrap'
import {Field, reduxForm} from 'redux-form'
import DropdownSelect from 'components/Fields/ReduxForm/DropdownSelect'
import SearchBar from 'components/Fields/ReduxForm/SearchBar'
import MenuTitle from 'components/MenuTitle'
import {isFullSiteMode} from 'utils/fullSite'

class ActionBar extends React.Component {

  static CUSTOMER_TYPE = [
    { id: 'LOYALTY', name: 'Loyalty Member' },
    { id: 'NON_LOYALTY', name: 'Non-Loyalty Member' }
  ]

  render () {
    let {onClickImport, onClickExport} = this.props

    return (
      <div>
        <MenuTitle menuTitle='Customers List' />
        { !isFullSiteMode() &&
          <div className={'pull-right'}>
            <DropdownButton title='Import / Export' bsStyle='primary'>
              <MenuItem onSelect={onClickImport}>Import Customer</MenuItem>
              <MenuItem divider />
              <MenuItem onSelect={onClickExport}>Export Customer</MenuItem>
            </DropdownButton>
          </div>
        }
        <div className={styles.wrapper}>
          <div className='row'>
            <div className='col-md-12 col-sm-12 col-xs-12'>
              <ul>
                <li className={`${styles['li-filter']}`}>
                  <Field
                    name='customerType'
                    component={DropdownSelect}
                    options={ActionBar.CUSTOMER_TYPE}
                    defaultOption={{id: 'ALL', name: 'All Customers'}}
                    id='filterSelectCustomerType'
                    style={{backgroundColor: 'white'}}
                    onChange={this._onChangeType}
                  />
                </li>
                <li className={`${styles['li-filter']} li-searching`}>
                  <Field
                    name='keyword'
                    component={SearchBar}
                    onChange={this._onChangeKeyword}
                    placeholder='Name, email, phone'
                    className='searchbar-customerlist'
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _onChangeKeyword = (event, keyword) => {
    this.props.onChangeKeyword(keyword)
  }

  _onChangeType = (event, type) => {
    this.props.onChangeType(type)
  }
}

ActionBar.propTypes = {
}

const mapForm = {
  form: 'search'
}

function mapStateToProps (state) {
  return {
    data: {
      customers: {
        list: state.customers.list
      }
    }
  }
}
export default connect(mapStateToProps)(reduxForm(mapForm)(ActionBar))



// WEBPACK FOOTER //
// ./app/pages/Customers/CustomerList/ListLoyalty/ActionBar/ActionBar.js